import { createFileRoute } from '@tanstack/react-router';
import { TwilioChannelsManager } from '@/features/omnichannel-twilio/components/TwilioChannelsManager';

export const Route = createFileRoute('/_authenticated/omnichannel-twilio-config')({
  component: OmnichannelTwilioConfigPage,
});

function OmnichannelTwilioConfigPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Omnicanal (Twilio) — Canais</h1>
        <p className="text-muted-foreground mt-1">
          Conecte os canais que serão atendidos pela ponte Twilio.
        </p>
      </div>
      <TwilioChannelsManager />
    </div>
  );
}
